import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47e8a6bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = {
  key: 1,
  class: "mt-20"
}
const _hoisted_3 = {
  key: 0,
  class: "wrapper-card"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Yes ")
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" No. I’ll enter my information manually. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_loader = _resolveComponent("app-loader")!
  const _component_registration_doctor_card = _resolveComponent("registration-doctor-card")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.dataRequest)
      ? (_openBlock(), _createBlock(_component_app_loader, {
          key: 0,
          message: "Searching for your information"
        }))
      : _createCommentVNode("", true),
    (!_ctx.dataRequest)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.doctor)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_registration_doctor_card, {
                  doctor: _ctx.doctor,
                  key: _ctx.doctor.npi,
                  select: false
                }, null, 8, ["doctor"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_app_button, {
            onClick: _withModifiers(_ctx.nextStep, ["prevent"]),
            type: "primary",
            class: "w-100 el-button-lg",
            disabled: !_ctx.doctor,
            round: ""
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["onClick", "disabled"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: _ctx.skipNpiUrl,
              class: "router-link mt-20"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}